<template>
  <pt-sample-recollect-table class="pt-sample-recollect-table__withData" :tableLabel="tableLabel" @getTableData="getTableData"
  :tableData="tableData" :totalNumber="totalNumber" v-loading='loading' isOutside>
       <slot/>
  </pt-sample-recollect-table>
</template>

<script>
import PtSampleRecollectTable from './index'
export default {
  name: 'pt-sample-recollect-table__withData',
  props: {
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      page: 0,
      loading: false
    }
  },
  components: {
    'pt-sample-recollect-table': PtSampleRecollectTable
  },
  watch: {
    queryParams: {
      handler: function (val) {
        this.getTableData(0)
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next, size) {
      let data = {
        ...this.queryParams,
        pageable: {
          page: page,
          size: size || this.pageSize
        }
      }
      this.page = page
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('waitingForSampleRecollect', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取带重采订单失败')
      })
    }
  }
}
</script>
